<template>
  <div class="post-container">
    <div class="info-list">
      <InfoTit>基本信息</InfoTit>
      <a-row>
        <a-col :span="12">
          <div class="info-item">
            <div>
              <div class="info-lb">招聘方案名称：</div>
              <div class="info-lb">岗位编号：</div>
            </div>
            <div>
              <div class="info-cont">{{ postInfo.planManagementName }}</div>
              <div class="info-cont">{{ postInfo.postNum }}</div>
            </div>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="info-item">
            <div>
              <div class="info-lb">招聘单位：</div>
            </div>
            <div>
              <div class="info-cont">{{ postInfo.orgName }}</div>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
    <div class="info-list">
      <InfoTit>岗位信息</InfoTit>
      <a-row>
        <a-col :span="12">
          <div class="info-item">
            <div>
              <div class="info-lb">招聘岗位：</div>
              <div class="info-lb">主管单位：</div>
            </div>
            <div>
              <div class="info-cont">{{ postInfo.postName }}</div>
              <div class="info-cont">{{ postInfo.mainOrgName }}</div>
            </div>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="info-item">
            <div>
              <div class="info-lb">招聘人数：</div>
              <div class="info-lb">岗位类别：</div>
            </div>
            <div>
              <div class="info-cont">{{ postInfo.needMemberNum }}</div>
              <div class="info-cont">{{ postInfo.postTypeName }}</div>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>

    <div class="info-list">
      <InfoTit>岗位要求</InfoTit>
      <a-row>
        <a-col :span="8">
          <div class="info-item">
            <div>
              <div class="info-lb">最高年龄：</div>
              <div class="info-lb" v-show="false">学历类别要求：</div>
              <div class="info-lb">最低学历学位要求：</div>
            </div>
            <div>
              <div class="info-cont">{{ +postInfo.ageLimit || '' }}</div>
              <div class="info-cont" v-show="false">{{ postInfo.educationalType }}</div>
              <div class="info-cont">{{ postInfo.educational }}</div>
            </div>
          </div>
        </a-col>
        <a-col :span="8">
          <div class="info-item">
            <div v-show="false">
              <div class="info-lb">性别要求：</div>
              <div class="info-lb">民族要求：</div>
              <div class="info-lb">户籍要求：</div>
            </div>
            <div v-show="false">
              <div class="info-cont">{{ postInfo.gender }}</div>
              <div class="info-cont">{{ postInfo.nation }}</div>
              <div class="info-cont">{{ postInfo.domicileRequirements }}</div>
            </div>
          </div>
        </a-col>
        <a-col :span="8">
          <div class="info-item">
            <div>
              <div class="info-lb" v-show="false">最低学历学位要求：</div>
              <div class="info-lb custom-margin">政治面貌要求：</div>
            </div>
            <div>
              <div class="info-cont" v-show="false">{{ postInfo.degreeRequirements }}</div>
              <div class="info-cont custom-margin1">{{ postInfo.politicalOutlook }}</div>
            </div>
          </div>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24" style="padding-left: 16px;">
          <div class="info-lb" >专业要求：<p v-if="postInfo.professional" class="info-cont" v-html="checkHtml(postInfo.professional)"></p></div>
          <div class="info-lb" >其它条件要求：<p  v-if="postInfo.otherRequirements" class="info-cont" v-html="checkHtml(postInfo.otherRequirements)"></p></div>
          <div class="info-lb" >首次聘期工作任务：<p v-if="postInfo.workTasks" class="info-cont" v-html="checkHtml(postInfo.workTasks)"></p></div>
          <!-- <div class="info-lb" v-if="postInfo.workTasks">所在区引才相关待遇：<p class="info-cont" v-html="checkHtml(postInfo.districtBenefits)"></p></div> -->
        </a-col>
      </a-row>
    </div>

    <div class="info-list" v-if="postInfo.employeeBenefit === 1 || isUnit === 'true'">
      <InfoTit>享受待遇</InfoTit>
      <div class="info-item">
        <div class="info-cont" v-html="checkHtml(postInfo.benefits)"></div>
      </div>
    </div>

    <!-- <div class="info-list">
      <InfoTit>所在区引才相关待遇</InfoTit>
      <div class="info-item">
        <div class="info-cont" v-html="checkHtml(postInfo.districtBenefits)"></div>
      </div>
    </div> -->

    <div class="info-list">
      <InfoTit>联系方式</InfoTit>
      <div class="info-item">
        <div>
          <div class="info-lb">地址：<span class="info-cont">{{ postInfo.contactAddress }}</span></div>
          <div class="info-lb">联系人：<span class="info-cont">{{ postInfo.contactMember }}</span></div>
          <div class="info-lb" v-if="postInfo.telephone">手机：<span class="info-cont">{{ postInfo.telephone }}</span></div>
          <div class="info-lb">座机：<span class="info-cont">{{ postInfo.landLine }}</span></div>
          <div class="info-lb" v-show="false">邮箱：<span class="info-cont">{{ postInfo.email }}</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InfoTit from '@/components/tit/info-tit.vue'

export default {
  components: {
    InfoTit
  },
  props: ['postInfo'],
  methods: {
    checkHtml (str) {
      return str?.replace(/\n/g, '<br/>') || ''
    }
  },
  computed:{
    isUnit(){
      return this.$route.query.isUnit
    }
  }
}
</script>

<style lang="less" scoped>
.post-container {
  position: relative;
  padding: 20px 191px 0 32px;
  background-color: #fff;
  .post-info {
    margin-top: 36px;
    .info-list {
      margin-top: 4px;
    }
  }
}

.info-item {
  display: flex;
  padding-left: 16px;
  margin-top: 16px;
}
.info-lb, .info-cont {
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 22px;
  min-height: 22px;
}
.info-article {
  margin-top: 10px;
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 22px;
}
.info-lb {
  color: #505D6E;
  margin-right: 4px;
}
.info-cont {
  color: #111;
}
.custom-margin{
  margin-left: -160px;
}
.custom-margin1{
  margin-left: -60px;
}
</style>